import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  SnippetsOutlined,
  HomeOutlined,
  InboxOutlined,
  DeliveredProcedureOutlined,
  UnorderedListOutlined,
  FileSyncOutlined,
  OrderedListOutlined,
  MenuOutlined,
  CloseOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import {
  Button,
  // Divider,
  Drawer,
  Image,
  Layout,
  Menu,
  Modal,
  Tag,
  theme,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserInfo } from "../../context";
import "./layout.css";
import AccountDetails from "../commissary/account/AccountDetails";

const { Header, Sider, Content, Footer } = Layout;

const CommissaryLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(
    window.innerWidth > 600 ? false : true
  );
  const navtab =
    window.location.pathname === "/"
      ? "1"
      : window.location.pathname === "/merchants"
      ? "2"
      : window.location.pathname === "/invetory"
      ? "3"
      : window.location.pathname === "/production"
      ? "4"
      : window.location.pathname === "/delivery"
      ? "5"
      : window.location.pathname === "/units"
      ? "6"
      : window.location.pathname === "/category"
      ? "7"
      : window.location.pathname === "/employee"
      ? "8"
      : "";
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  // const [modeStyle, setModeStyle] = useState("inline");
  // const [themeStyle, setThemeStyle] = useState("light");
  const themeStyle = "dark";
  const [current, setCurrent] = useState("1");
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  const [accountDetailsDrawer, setAccountDetailsDrawer] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const items = [
    {
      label: (
        <Link to="/" relative="path">
          Products
        </Link>
      ),
      key: "1",
      icon: <SnippetsOutlined />,
    },
    {
      label: (
        <Link to="/merchants" relative="path">
          Merchants
        </Link>
      ),
      key: "2",
      icon: <HomeOutlined />,
    },
    {
      label: (
        <Link to="/invetory" relative="path">
          Inventory
        </Link>
      ),
      key: "3",
      icon: <InboxOutlined />,
    },
    {
      label: (
        <Link to="/production" relative="path">
          Production
        </Link>
      ),
      key: "4",
      icon: <FileSyncOutlined />,
    },
    {
      label: (
        <Link to="/delivery" relative="path">
          Delivery
        </Link>
      ),
      key: "5",
      icon: <DeliveredProcedureOutlined />,
    },
    {
      label: (
        <Link to="/units" relative="path">
          Units
        </Link>
      ),
      key: "6",
      icon: <UnorderedListOutlined />,
    },
    {
      label: (
        <Link to="/category" relative="path">
          Category
        </Link>
      ),
      key: "7",
      icon: <OrderedListOutlined />,
    },
    {
      label: (
        <Link to="/employee" relative="path">
          Employee
        </Link>
      ),
      key: "8",
      icon: <UserOutlined />,
    },
  ];

  const MenuonClick = (e) => {
    setCurrent(e.key);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      handleLogoutTkn();
    }, 2000);
  };

  useEffect(() => {}, [current]);

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      hasSider={window.innerWidth > 500 ? true : false}
    >
      {window.innerWidth > 500 && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: themeStyle === "dark" ? "#001529" : "#fff",
          }}
        >
          {/* <div
            style={{
              height: collapsed ? 45 : 100,
              margin: 16,
              border: "1px solid rgba(255, 255, 255, .2)",
              background: themeStyle === "dark" ? "transparent" : "#001529",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // padding: 5,
            }}
          >
            <Image
              width={"auto"}
              height={collapsed ? 45 : 100}
              src={
                userData.data.userscominfo.business_logo !== null
                  ? `${process.env.REACT_APP_API_IMAGE}logo/${userData.data.userscominfo.business_logo}`
                  : require("./../../assets/logo.png")
              }
              placeholder={"logo"}
              preview={false}
            />
          </div> */}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              // border: "1px solid red",
            }}
          >
            <div
              style={{
                height: collapsed ? 45 : 100,
                width: collapsed ? 45 : 100,
                margin: 16,
                // border: "1px solid rgba(255, 255, 255, .2)",
                background: themeStyle === "dark" ? "transparent" : "#001529",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // padding: 5,
                // border: "1px solid red",
              }}
            >
              <Image
                width={"auto"}
                height={collapsed ? 45 : 100}
                src={
                  userData.data.userscominfo.business_logo !== null
                    ? `${process.env.REACT_APP_API_IMAGE}logo/${userData.data.userscominfo.business_logo}`
                    : require("./../../assets/logo.png")
                }
                placeholder={"logo"}
                preview={false}
              />
            </div>
          </div>

          <Menu
            onClick={MenuonClick}
            defaultSelectedKeys={[navtab]}
            // mode={modeStyle}
            theme={themeStyle}
            items={items}
          />

          {/* <Divider /> */}
        </Sider>
      )}

      <Layout
        className="container3"
        style={{
          marginLeft: window.innerWidth > 500 ? (collapsed ? 80 : 200) : 0,
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              {window.innerWidth > 500 ? (
                collapsed ? (
                  <MenuUnfoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                ) : (
                  <MenuFoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                )
              ) : (
                <MenuOutlined
                  style={{ marginLeft: 10, fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpenDrawer(!openDrawer)}
                />
              )}
              <Tag
                icon={<ShopOutlined />}
                color="#55acee"
                style={{ marginLeft: 10 }}
              >
                Commissary
              </Tag>
            </div>

            <div style={{ marginRight: 20 }}>
              <Tooltip
                placement="bottomRight"
                title={"Account"}
                color={"#2db7f5"}
              >
                <UserOutlined
                  style={{ marginRight: 15, fontSize: 15 }}
                  className="trigger"
                  onClick={() => {
                    // navigate("/account")
                    setAccountDetailsDrawer(true);
                  }}
                />
              </Tooltip>
              <Tooltip
                placement="bottomRight"
                title={"Logout"}
                color={"#2db7f5"}
              >
                <LogoutOutlined
                  style={{ fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpen(true)}
                />
              </Tooltip>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflow: "initial",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          BBMS ©2023 Created by Nehemiah Solutions
        </Footer>
      </Layout>

      <Drawer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        placement="left"
        closable={false}
        bodyStyle={{ backgroundColor: "#001529" }}
        width={220}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setOpenDrawer(false);
                }}
                style={{ color: "#fff", backgroundColor: "#001529" }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        <Menu
          onClick={MenuonClick}
          defaultSelectedKeys={[navtab]}
          // mode={modeStyle}
          theme={themeStyle}
          items={items}
        />
      </Drawer>

      <Modal
        title="Are you sure to logout?"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
      />

      {accountDetailsDrawer && (
        <AccountDetails
          open={accountDetailsDrawer}
          close={() => setAccountDetailsDrawer(false)}
        />
      )}
    </Layout>
  );
};
export default CommissaryLayout;
